import footerLogo from "../../assets/New/footer-new-logo.svg";
import { Link } from "react-router-dom";
import { FaInstagram, FaYoutube, FaPinterestP } from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
import "./index.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-logo-section">
        <div className="footer-divider-line"></div>
        <img src={footerLogo} alt="Icon" className="footer-logo" />
        <div className="footer-divider-line"></div>
      </div>
      <div className="footer-app-badges-section">
        <h3 className="footer-app-title">Download Clap Kartel App</h3>
        <div className="footer-app-badges">
          <a href="https://play.google.com/store/apps/details?id=com.clapkartal.clapkartal" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="footer-store-badge" />
          </a>
          <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" className="footer-store-badge" />
        </div>
      </div>
      <div className="footer-social-wrapper">
        <div className="footer-social-icons">
          <a href="https://www.instagram.com/clapkartelcinema/" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper instagram">
              <FaInstagram />
            </div>
          </a>
          <a href="https://www.threads.net/@clapkartelcinema" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper threads">
              <FaThreads />
            </div>
          </a>
          <a href="https://www.youtube.com/@ClapKartelCinema" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper youtube">
              <FaYoutube />
            </div>
          </a>
          <a href="https://x.com/ClapKartelCine" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper x-twitter">
              <FaXTwitter />
            </div>
          </a>
          <a href="https://www.pinterest.com/clapkartelcinema/" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper pinterest">
              <FaPinterestP />
            </div>
          </a>
        </div>
      </div>
      <div className="footer-text-section">
        <p className="footer-terms-text">
          <Link to="/terms-conditions" className="footer-link" style={{ marginRight: "10px" }}>Terms & Conditions</Link> 
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </p>
        <p className="footer-copyright-text">
          Copy Right © Clap Kartel. All Rights Reserved | Concept & Designed by
          eParivartan
        </p>
      </div>
    </div>
  );
};

export default Footer;